import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { CustomerComponent } from '../customer/customer.component';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SupplierComponent } from '../supplier/supplier.component';


@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  private dp = [];
  displayedColumns = ['date', 'operation_type', 'comment', 'view'];
  displayedColumns2 = ['date', 'operation_type', 'comment'];

  public title = '';
  no; type; name; type_name;


  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<CustomerComponent>;
  addDialogRef2: MatDialogRef<SupplierComponent>;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'from_date': new Date(), 'to_date': new Date(), 'title': '' };

  customer_detail = [];
  supplier_detail = [];

  Customer_Profile; Supplier_Profile; Success_Msg; Error_Msg; Customer_Name;
  Supplier_Name; From_Date; To_Date; Customer_No; Supplier_No;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private router: Router, private route: ActivatedRoute,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Customer_Profile').subscribe((res: string) => {
      this.Customer_Profile = res;
    });

    translate.get('Supplier_Profile').subscribe((res: string) => {
      this.Supplier_Profile = res;
    });

    translate.get('Customer_Name').subscribe((res: string) => {
      this.Customer_Name = res;
    });

    translate.get('Supplier_Name').subscribe((res: string) => {
      this.Supplier_Name = res;
    });

    translate.get('Customer_No').subscribe((res: string) => {
      this.Customer_No = res;
    });

    translate.get('Supplier_No').subscribe((res: string) => {
      this.Supplier_No = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });
  }


  ngOnInit() {
    this.route.params.subscribe(params => {
      // console.log(params);
      this.type = params['type'];
      this.no = params['no'];

      //////////////////////////// CUSTOMER ////////////////////////////

      if (this.type == 'customer') {
        this.title = this.Customer_Profile;
        this.type_name = this.Customer_Name;
        this.model['title'] = this.title;

        //////////////////////////// Customer Detail ////////////////////////////

        let query = "SELECT `customer`.* FROM `customer` WHERE `customer`.`status` = '1' AND `customer`.`acct_number` = '" + this.no + "'";
        let obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            this.customer_detail = data.data['list'];
            this.name = this.customer_detail['0']['customer_name'];
          });
      }
      //////////////////////////// SUPPLIER ////////////////////////////

      else if (this.type == 'supplier') {
        this.title = this.Supplier_Profile;
        this.type_name = this.Supplier_Name;
        this.model['title'] = this.title;

        //////////////////////////// Customer Detail ////////////////////////////

        let query = "SELECT `supplier`.* FROM `supplier` WHERE `supplier`.`status` = '1' AND `supplier`.`acct_number` = '" + this.no + "'";
        let obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            this.supplier_detail = data.data['list'];
            this.name = this.supplier_detail['0']['supplier_name'];
          });
      }

      //////////////////////////// Get Operations ////////////////////////////
      let obj1 = { cmd: 'getProfileOperation', acct_number: this.no, type: this.type };

      this.utils.invokeHttp(this.applicationConstants.functionFile, obj1)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.dp = data.status['msg'];
          this.dp.forEach(element => {
            element.date = (element.date).substring(0, 10);
          });
          this.dataSource = new MatTableDataSource(this.dp);
          this.dataSource.sort = this.sort;
        });

    });

    this.model['from_date'] = undefined;
    this.model['to_date'] = undefined;
  }

  search() {

    let from_date; let to_date;

    if (this.model['from_date'] != undefined) {
      from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + " 00:00:00";
    }

    if (this.model['to_date'] != undefined) {
      to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate() + " 23:59:59";
    }

    let obj = {
      cmd: 'getProfileOperation', acct_number: this.no, from_date: from_date, to_date: to_date, 
      type: this.type
    };

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.status['msg'];
        this.dp.forEach(element => {
          element.date = (element.date).substring(0, 10);
        });
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  view(row) {

    //////////////////////////// CUSTOMER ////////////////////////////

    if (this.type == 'customer') {
      if (row.operation_type_en == 'Invoice')
        this.router.navigate(['sub_menu/8/invoice_detail/invoice/' + row.no + '/customer_list']);

      else if (row.operation_type_en == 'Return Invoice')
        this.router.navigate(['sub_menu/8/invoice_detail/return_invoice/' + row.no + '/customer_list']);

      else if (row.operation_type_en == 'Cash Receipt')
        this.router.navigate(['sub_menu/3/receipt_detail/cash_receipt/' + row.no]);

      else if (row.operation_type_en == 'Customer Base') {

        let query = "SELECT `country`.`country_id` FROM `country`, `city` WHERE `country`.`status` = '1' AND `city`.`city_id`= "
          + this.customer_detail['0'].city_id + " AND `city`.`country_id` = `country`.`country_id`";
        let obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let country = data.data['list'];
            let country_id = country['0']['country_id'];

            let dialog_data = [{
              'table_name': 'customer',
              'customer_id': this.customer_detail['0']['customer_id'],
              'customer_name': this.customer_detail['0'].customer_name,
              'customer_name_en': this.customer_detail['0'].customer_name_en,
              'customer_no': this.customer_detail['0'].customer_no,
              'customer_category_id': this.customer_detail['0'].customer_category_id,
              'city_id': this.customer_detail['0'].city_id,
              'tax_no': this.customer_detail['0'].tax_no,
              'address': this.customer_detail['0'].address,
              'mobile': this.customer_detail['0'].mobile,
              'phone1': this.customer_detail['0'].phone1,
              'phone2': this.customer_detail['0'].phone2,
              'fax': this.customer_detail['0'].fax,
              'email': this.customer_detail['0'].email,
              'represent1': this.customer_detail['0'].represent1,
              'represent1_mobile': this.customer_detail['0'].represent1_mobile,
              'represent2': this.customer_detail['0'].represent2,
              'represent2_mobile': this.customer_detail['0'].represent2_mobile,
              'def_rep_no': this.customer_detail['0'].def_rep_no,
              'claim_day': this.customer_detail['0'].claim_day,
              'comment': this.customer_detail['0'].comment,
              'car_type': this.customer_detail['0'].car_type,
              'car_model': this.customer_detail['0'].car_model,
              'car_color': this.customer_detail['0'].car_color
            }, { 'country_id': country_id }];

            this.addDialogRef = this.dialog.open(CustomerComponent, {
              hasBackdrop: false,
              data: dialog_data
            });
            this.addDialogRef
              .afterClosed()
              .subscribe(result => {
                //this.router.navigate(['sub_menu/8/customer_list']);
              });
          });
      }
    }

    //////////////////////////// SUPPLIER ////////////////////////////

    else if (this.type == 'supplier') {
      if (row.operation_type_en == 'Supplier Invoice')
        this.router.navigate(['sub_menu/2/invoice_detail/supplier_invoice/' + row.no + '/supplier_list']);

      else if (row.operation_type_en == 'Return Supplier Invoice')
        this.router.navigate(['sub_menu/2/invoice_detail/return_supplier_invoice/' + row.no + '/supplier_list']);

      else if (row.operation_type_en == 'Payment Voucher')
        this.router.navigate(['sub_menu/3/receipt_detail/payment_voucher/' + row.no]);

      else if (row.operation_type_en == 'Supplier Base') {

        let query = "SELECT `country`.`country_id` FROM `country`, `city` WHERE `country`.`status` = '1' AND `city`.`city_id`= "
          + this.supplier_detail['0'].city_id + " AND `city`.`country_id` = `country`.`country_id`";
        let obj = { cmd: 'getList', query: query };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            let country = data.data['list'];
            let country_id = country['0']['country_id'];

            let dialog_data = [{
              'table_name': 'supplier',
              'supplier_id': this.supplier_detail['0'].supplier_id,
              'supplier_name': this.supplier_detail['0'].supplier_name,
              'supplier_name_en': this.supplier_detail['0'].supplier_name_en,
              'supplier_no': this.supplier_detail['0'].supplier_no,
              'supplier_category_id': this.supplier_detail['0'].supplier_category_id,
              'city_id': this.supplier_detail['0'].city_id,
              'tax_no': this.supplier_detail['0'].tax_no,
              'address': this.supplier_detail['0'].address,
              'mobile': this.supplier_detail['0'].mobile,
              'phone1': this.supplier_detail['0'].phone1,
              'phone2': this.supplier_detail['0'].phone2,
              'fax': this.supplier_detail['0'].fax,
              'email': this.supplier_detail['0'].email,
              'represent1': this.supplier_detail['0'].represent1,
              'represent1_mobile': this.supplier_detail['0'].represent1_mobile,
              'represent2': this.supplier_detail['0'].represent2,
              'represent2_mobile': this.supplier_detail['0'].represent2_mobile,
              'comment': this.supplier_detail['0'].comment
            },
            { 'country_id': country_id }];

            this.addDialogRef2 = this.dialog.open(SupplierComponent, {
              hasBackdrop: false,
              data: dialog_data
            });
            this.addDialogRef
              .afterClosed()
              .subscribe(result => {
                //this.router.navigate(['sub_menu/2/supplier_list']);
              });

          });
      }
    }

  }

  print() {
    let from_date = ''; let to_date = '';
    if (this.model['from_date'] != undefined) {
      from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate();
    }

    if (this.model['to_date'] != undefined) {
      to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate();
    }

    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"><h2> ' + this.title + '</h2></td></tr>';
    if (this.type == 'customer')
      html_data += '<tr><td width="33%"> ' + this.Customer_Name + ': ' + this.name + '</td><td width="33%"> ' + this.Customer_No + ': ' + this.no + '</td></tr>';
    else if (this.type == 'supplier')
      html_data += '<tr><td width="33%"> ' + this.Supplier_Name + ': ' + this.name + '</td><td width="33%"> ' + this.Supplier_No + ': ' + this.no + '</td></tr>';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('profile_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }
}
